import * as tslib_1 from "tslib";
import { loadMrsConnectedAccounts } from '../utils/loadMrsConnectedAccounts';
import { loadDefaultAddressOption } from '../utils/loadDefaultAddressOption';
export function initConnectedAccountsFull() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loadMrsConnectedAccounts()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, loadDefaultAddressOption()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=initConnectedAccountsFull.js.map